export const EVENTS = {
  READY: 'duda-widgets:ready',
  PACKAGE_FILTER: 'package.onFilter'
}
